import { render, staticRenderFns } from "./Drepturi_dialog.vue?vue&type=template&id=fa749c36&scoped=true&"
import script from "./Drepturi_dialog.vue?vue&type=script&lang=js&"
export * from "./Drepturi_dialog.vue?vue&type=script&lang=js&"
import style0 from "./Drepturi_dialog.vue?vue&type=style&index=0&id=fa749c36&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa749c36",
  null
  
)

export default component.exports